import { Component, Input, OnInit } from "@angular/core";

import { ViewCell } from "ng2-smart-table";
import { PRIORITIES } from "../../@core/data/default-list";

@Component({
  template: `<strong [ngClass]="renderCss" style="text-align: left;">
    {{ renderValue }}
  </strong>`,
})
export class StbCustomRenderPriorityComponent implements ViewCell, OnInit {
  renderValue: string;
  renderCss: string;
  priorities = PRIORITIES;

  @Input() value: number;
  @Input() rowData: any;

  ngOnInit() {
    this.renderValue = isNaN(this.value)
      ? this.priorities[0].title
      : this.priorities[this.value].title;
    this.renderCss = isNaN(this.value)
      ? "text-basic"
      : "text-" + this.priorities[this.value].status;
  }
}
